import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import { color } from 'echarts/lib/export';

export default class StackupCardItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        // this.calcPercentileFromZscore = this.calcPercentileFromZscore.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);
        this.formatQuartileDisplay = this.formatQuartileDisplay.bind(this);


        this.showPopup = this.showPopup.bind(this);

        this.generateBottomContent = this.generateBottomContent.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, number) {

        let endText = '';
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    formatQuartileDisplay(num, type) {
        let result = "0";

        if (num / 1000000 >= 1) {
            result = (num / 1000000.0).toFixed(1) + "M";
        } else if (num / 1000 >= 1) {
            result = (num / 1000.0).toFixed(1) + "K";
        } else {
            result = num.toFixed(1);
        }

        if (type === 'MNY') { result = "$" + result; }
        if (type === 'PCT') { result = result + "%"; }

        return result;
    }

    showPopup() {
        let identity = this.props.identity;

        let min = this.formatQuartileDisplay(identity.minimum, identity.type);
        let q1 = this.formatQuartileDisplay(identity.bottomQtr, identity.type);
        let h = this.formatQuartileDisplay(identity.half, identity.type);
        let q3 = this.formatQuartileDisplay(identity.topQtr, identity.type);
        let max = this.formatQuartileDisplay(identity.maximum, identity.type);

        let descriptionText = this.props.masterKpiList[identity.masterKPIId].description;

        let displayNums = ["Below", q1, h, q3, "Above"];
        if (this.props.masterKpiList[identity.masterKPIId] != undefined && this.props.masterKpiList[identity.masterKPIId].isNegativeSlope) {
            displayNums.reverse();
        }

        alert((
            <div className={"stackup-popup-outer"}>
                <div className={"kpi-name"}>{identity.kpiDesc}</div>
                <div className={"kpi-description"}>{descriptionText}</div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q4"}></div>
                        </div>
                        <div className={"quartile-range"}>{"Q4: " + displayNums[4] + " " + displayNums[3]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q3"}>
                                <div className={"tl"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q3: " + displayNums[2] + " - " + displayNums[3]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q2"}>
                                <div className={"tl"}></div>
                                <div className={"bl"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q2: " + displayNums[1] + " - " + displayNums[2]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q1"}>
                                <div className={"tl"}></div>
                                <div className={"bl"}></div>
                                <div className={"br"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q1: " + displayNums[0] + " " + displayNums[1]}</div>
                    </div>
                </div>
            </div>
        ));
    }

    generateBottomContent() {
        let identity = this.props.identity;

        let min = this.formatQuartileDisplay(identity.minimum, identity.type);
        let q1 = this.formatQuartileDisplay(identity.bottomQtr, identity.type);
        let h = this.formatQuartileDisplay(identity.half, identity.type);
        let q3 = this.formatQuartileDisplay(identity.topQtr, identity.type);
        let max = this.formatQuartileDisplay(identity.maximum, identity.type);

        let indicatorStyle = {};
        if (this.props.resetSlider) {
            indicatorStyle.left = "-0.25rem";
        } else {
            indicatorStyle.left = "calc(" + ((identity.percentile * 100.0).toFixed(2)) + "% - 0.25rem)";
        }

        let displayNums = [min, q1, h, q3, max];
        if (this.props.masterKpiList[identity.masterKPIId] != undefined && this.props.masterKpiList[identity.masterKPIId].isNegativeSlope) {
            displayNums.reverse();
        }

        return (
            <div className={"stackup-card-bottom-container"} onClick={this.showPopup}>
                <div className={"color-bar"}>
                    <div className={"color-item"}><div className={"num-display"}>{/*displayNums[0]*/}</div></div>
                    <div className={"color-item"}><div className={"num-display"}>{displayNums[1]}</div></div>
                    <div className={"color-item"}><div className={"num-display"}>{displayNums[2]}</div></div>
                    <div className={"color-item"}><div className={"num-display"}>{displayNums[3]}</div><div className={"num-display"}>{/*displayNums[4]*/}</div></div>
                    <div className={"indicator"} style={indicatorStyle}>
                        <div className={"block"}></div>
                        <div className={"triangle"}></div>
                        <div className={"stem"}></div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        let identity = this.props.identity;

        let outerClass = "stackup-card-item-outer"
        let outerStyle = {}

        if (!this.props.active && !this.props.pickMode) {
            outerClass += ' stackup-card-item-outer--inactive'
        }

        let percentile = (identity.percentile * 100.0).toFixed(1);

        let leftJsx = null;
        if (this.props.pickMode) {

            let icon = null;

            if (this.props.active) {
                icon = 'lock_open';
            } else {
                icon = 'lock_outline';

                outerStyle.opacity = '0.5';
            }

            let tmpJsx = null;
            if (icon != 'lock_open') {
                tmpJsx = <div className="material-icons stackup-card-item-icon">{icon}</div>;
            } else {
                tmpJsx = (
                    <svg version="1.1" className="stackup-card-item-icon-svg" id="asdf" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-12 -12 72 72" >
                        <path class="st0" d="M0,0h48v48H0V0z" />
                        <path class="st1" d="M24,34c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S21.8,34,24,34z M36,16h-2v-4c0-5.5-4.5-10-10-10
	                        s-8.7,4.7-9.4,6.6l3.4,1.8c0.8-2,2.6-4.6,6-4.6s6.2,2.8,6.2,6.2v4H12c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V20
	                        C40,17.8,38.2,16,36,16z M36,40H12V20h24V40z"/>
                    </svg>
                );
            }

            leftJsx = (
                <div className="stackup-card-item-icon-container" onClick={this.props.toggleKpi.bind(null, identity)}>
                    {tmpJsx}
                </div>
            );

        } else {

            let quartileNum = 0;
            let quartileColor = 'red';
            let quartileRatio = [1, 0];
            if (percentile >= 75.0) {
                quartileNum = 4;
                quartileColor = 'rgba(73, 202, 117, 1) ';
                quartileRatio = [1, 0];
            } else if (percentile >= 50.0) {
                quartileNum = 3;
                quartileColor = 'rgba(234, 240, 87, 1)';
                quartileRatio = [3, 1];
            } else if (percentile >= 25.0) {
                quartileNum = 2;
                quartileColor = 'rgba(255, 157, 0, 1)';
                quartileRatio = [1, 1];
            } else {
                quartileNum = 1;
                quartileColor = 'rgba(242, 88, 88, 1)';
                quartileRatio = [1, 3];
            }

            leftJsx = (
                <div className="stackup-card-item-icon-container">
                    <ReactEcharts
                        className="metrics-bottom-bar-period-chart"
                        height={'100%'}
                        option={{
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b}: {c} ({d}%)",
                                show: false
                            },
                            legend: {
                                orient: 'vertical',
                                x: 'left',
                                data: [quartileColor, 'Grey']
                            },
                            series: [
                                {
                                    name: 'Period',
                                    selectedMode: false,
                                    type: 'pie',
                                    radius: ['0%', '97%'],
                                    avoidLabelOverlap: false,
                                    label: {
                                        normal: {
                                            show: false,
                                            position: 'center'
                                        },
                                        emphasis: {
                                            show: false,
                                            textStyle: {
                                                fontSize: '30',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    color: [quartileColor, '#F8F9FB'],
                                    data: [
                                        { value: quartileRatio[0], name: '' },
                                        { value: quartileRatio[1], name: '' }
                                    ]
                                }
                            ]
                        }}
                    />
                </div>
            );
        }

        let centerJsx = (
            <div className="stackup-card-name-container" onClick={this.showPopup}>
                <div className="stackup-card-name">{identity.kpiDesc}</div>
            </div>
        );

        let totalTopText = percentile + '%';
        let totalBottomText = this.convertToDisplay(identity.type, identity.rawVal.toFixed(2));

        if (percentile < 0) {
            totalTopText = "Out of Range";
        }

        let bottomJsx = this.generateBottomContent();

        return (
            <div className={outerClass} style={outerStyle}>
                {leftJsx}
                {centerJsx}
                <div className="stackup-card-numbers-container" onClick={this.showPopup}>
                    <div className="stackup-card-numbers-top">{totalTopText}</div>
                    <div className="stackup-card-numbers-bottom">{totalBottomText}</div>
                </div>
                {bottomJsx}
            </div>
        );
    }
}